export const FETCH_STATEMENTS_REQUEST = "FETCH_STATEMENTS_REQUEST";
export const FETCH_STATEMENTS_SUCCESS = "FETCH_STATEMENTS_SUCCESS";
export const FETCH_STATEMENTS_FAILURE = "FETCH_STATEMENTS_FAILURE";
